import { fetchWithHandling } from "../ApiUtils";

const URL = `${process.env.REACT_APP_API_URL}/api/member`
const target = "/member/dashboard";

/**
 * GET request to fetch all swag options.
 */
export const getSwagItems = async () => {
    const response = await fetch(`${URL}/swag`, {
        headers: {
            "Content-Type": "application/json"
            // TODO: add authentication headers once Shibboleth is implemented
        },
        credentials: "include",
        method: 'GET'
    });
    const responseBody = await response.json();
    return responseBody.swagItems;
}

/**
 * GET request to fetch member details (name, active semesters, earned rewards)
 */
export const getMemberDetails = async () => {
    return fetchWithHandling(`${URL}/info`, target, {
        method: "GET"
    });
}